export const hasPermissionRouteName = (
  routeName: string,
  granted: string[]
) => {
  return granted?.includes(routeName);
};

export const userHasAuthorization = (
  userMenus: Array<string>,
  menu: string
) => {
  /* // console.log('Menu tio check : ', menu, userMenus)
  if (userMenus.includes(menu) || userMenus.includes("*")) {
    return true;
  }
  return false; */
  return (
    userMenus.includes("*") ||
    userMenus.some((m) => m.startsWith(menu))
  );
};
